import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from 'js/src/libs/RootState';

export type EditorAppState = {
    activeSceneGroupIndex: number;
    /** Index of the active scene within `luminary.sceneGroups[activeSceneGroupIndex]`. */
    activeSceneIndex: number;
};

const initialState: EditorAppState = {
    activeSceneGroupIndex: 1,
    activeSceneIndex: 0,
};

export const editorAppSlice = createSlice({
    name: 'editorApp',
    initialState,
    reducers: {
        setActiveSceneGroupIndex: (state, action: PayloadAction<number>) => {
            state.activeSceneGroupIndex = action.payload;
        },
        setActiveSceneIndex: (state, action: PayloadAction<number>) => {
            state.activeSceneIndex = action.payload;
        },
    },
});

export const { setActiveSceneGroupIndex, setActiveSceneIndex } = editorAppSlice.actions;
export const editorAppReducer = editorAppSlice.reducer;

export function getEditorAppActiveSceneGroupIndex(state: RootState): number {
    const editorApp = state.editorApp;
    if (!editorApp) {
        return 1;
    }
    return editorApp.activeSceneGroupIndex ?? 1;
}

export function getEditorAppActiveSceneIndex(state: RootState): number {
    const editorApp = state.editorApp;
    if (!editorApp) {
        return 0;
    }
    return editorApp.activeSceneIndex ?? 0;
}
